import { ModuleWithProviders, NgModule } from '@angular/core';
import { ANALYSIS_ROUTE_PROVIDERS } from './providers/route.provider';

import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ThemeLeptonModule } from '@volo/abp.ng.theme.lepton';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [],
  imports: [
    CoreModule, 
    ThemeSharedModule,
    ThemeLeptonModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    FormsModule, 
    NgbModule
  ],
  exports: [
    CoreModule,
    ThemeSharedModule,
    ThemeLeptonModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    NgbModule
  ]
})
export class AnalysisConfigModule {
  static forRoot(): ModuleWithProviders<AnalysisConfigModule> {
    return {
      ngModule: AnalysisConfigModule,
      providers: [ANALYSIS_ROUTE_PROVIDERS],
    };
  }
}
